import {ISignatureRole} from './SubscriptionDocumentUpload';
import { IFrontFaceQuestion } from './template-signrole-question';

export enum PilotTestStatus {
  'Ready For Pilot Test',
  'Resume Pilot Test',
  'Rejected',
  'Approved'
}

export interface IAgreementPilotTestViewModel {
  investorTypeArray: IInvestorTypePilotTest[];
  signerRoleOptions: { label: string, value: number }[];
  questionContent?: string;
  signRoleQuesitons?: IFrontFaceQuestion[];
  signerRoleList?: ISignatureRole[];
  investorTypeSignRoleMappings?: IInvestorTypeSignRoleMapping[];
  investorTypeQuesitonContent?:string;
  isQuestionaireNeeded?:boolean;
  isSignOnline?:boolean;
}

export interface IInvestorTypeSignRoleMapping {
  investorTypeId: number;
  signerRoleIdList?: number[];
}

export interface IInvestorTypePilotTest {
  id: number;
  investorTypeId: number;
  investorTypeName: string;
  status: PilotTestStatus;
  signerRoleId?: number;
  answers?: { questionId: number, answers: string[] }[];
  gpRoleId?: number;
}

export enum SignRoleQuestionMode {
  none,
  LegacyHardCode,
  FrontFaceQuestion
}

export interface ISignatureRoleOption {
  value: number;
  label: string;
}

export interface ICompletePilotTestParam {
  investorTypeEntityId: number;
  status: PilotTestStatus;
}

export interface IRejectNoteParam {
  note: string;
  stepName: string;
  investorStatusEntityId: number;
}

export enum WizardMode {
  'Default',
  'Pilot Test',
  'Preview',
  'Read Only',
}